export enum FamilyMode {IMMEDIATE = "Immediate", OTHER = "Other", EXTENDED = "Extended"}